import { warn } from './warn';

import type { CarrotQuestProperties } from '../CarrotQuestManager.types';

export const makeScript = ({ id }: CarrotQuestProperties): string => {
  if (!id) warn('CarrotQuest Id is required');

  return `
    "use strict";
    
    // Инициализация carrotquest объекта
    (function(){
      if (typeof carrotquest === "undefined") {
        window.carrotquest = {};
        window.carrotquestasync = [];
        carrotquest.settings = {};
        
        var methods = ["connect","track","identify","auth","oth","onReady","addCallback","removeCallback","trackMessageInteraction"];
        for (var i = 0; i < methods.length; i++) {
          carrotquest[methods[i]] = (function(methodName) {
            return function() {
              window.carrotquestasync.push(methodName, arguments);
            };
          })(methods[i]);
        }
      }
    })();
    
    function createProxyIframe(){
      let iframe=document.createElement("iframe");
      iframe.setAttribute("id","proxy-iframe");
      iframe.setAttribute("name","proxy-iframe");
      iframe.setAttribute("style","display: block !important; width: 0 !important; height: 0 !important; border: none !important; position: absolute !important; top: 0 !important; left: 0 !important; visibility: hidden !important;");
      iframe.addEventListener("load",function(){
        createScriptIframe();
        insertScriptChunk("chat");
        insertScriptChunk("launcher");
        insertScriptChunk("notification");
        insertScriptChunk("tooltip");
      },{once:!0});
      
      let isInserted=!1;
      document.readyState!=="loading"?document.body.appendChild(iframe):document.addEventListener("readystatechange",function(){
        document.readyState!=="loading"&&!isInserted&&(isInserted=!0,document.body.appendChild(iframe))
      });
      
      function createScriptIframe(){
        let indexScript=document.createElement("script");
        indexScript.type="text/javascript";
        indexScript.async=!0;
        let src="https://cdn.carrotquest.app/index.js";
        indexScript.src=src;
        indexScript.type="module";
        let proxyIframe=document.getElementById("proxy-iframe").contentWindow;
        proxyIframe.document.head.appendChild(indexScript);
        proxyIframe.parent.dashlyExecuteEval=code=>{eval(code)};
      }
      
      function insertScriptChunk(r){
        let e=document.createElement("script"),t;
        t="https://cdn.carrotquest.app/"+r+".js";
        e.src=t;
        e.type="module";
        document.getElementById("proxy-iframe").contentWindow.document.head.appendChild(e);
      }
    }
    createProxyIframe();
    carrotquest.connect("${id}");
  `;
};
